import { AnyUser } from "@megaron/access-control";
import { HttpService } from "@megaron/http-service";
import { HandlerMap } from "@megaron/http-service-host";

import { commentsActions } from "./comments";

export const commentsHttpService = HttpService({
  ...commentsActions,
});

export type CommentsHandlers = HandlerMap<typeof commentsHttpService, AnyUser>;
